/* eslint-disable @typescript-eslint/no-explicit-any */
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { Model } from '@adobe/aem-spa-page-model-manager';
import { respGridUtil, updateAEMCQKeys, StringIndexedObject } from '@marriott/mi-ui-library';

export function getAEMCQItemsForProps<T extends StringIndexedObject>(props: T) {
  const updatedProps = updateAEMCQKeys(props);

  return updatedProps?.['cqItems'];
}

export function getAEMItemsSorted(item: Model): [string, Model][] {
  const itemsContent = item?.[':items'];
  const itemsOrder = item?.[':itemsOrder'];
  if (!itemsContent) {
    return [];
  }
  const items = Object.entries(itemsContent);
  return itemsOrder ? items.sort((a: any, b: any) => itemsOrder.indexOf(a[0]) - itemsOrder.indexOf(b[0])) : items;
}

export function CreateCardToPublish({ page }: { page: Model }) {
  const pageItems: [string, Model][] = getAEMItemsSorted(page);

  if (pageItems?.length) {
    return (
      <>
        {pageItems.map<JSX.Element>(([itemKey, item]) => {
          const model = respGridUtil({
            ...page,
            ':items': { [itemKey]: item },
          });

          return <ResponsiveGrid model={model} {...model} key={itemKey} customClassName={'p-0'} />;
        })}
      </>
    );
  }

  return null;
}
